var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"variant":"danger","show":true},domProps:{"innerHTML":_vm._s(_vm.error)}}),_c('button',{staticClass:"btn btn-primary btn-block",on:{"click":function($event){return _vm.tryAgain()}}},[_vm._v("Try Again")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }